// recommended-for-banner.js
if (!customElements.get('recommended-for-banner')) {
  customElements.define('recommended-for-banner', class extends HTMLElement {
    constructor() {
      super();
      this.data = [];
      try {
        this.data = JSON.parse(this.querySelector('script').textContent);
      } catch (e) {
        console.error('Failed to parse recommended_for data', e);
      }
    }
    connectedCallback() {
      if (window.FoxThemeEvents) {
        this.unsubscribe = window.FoxThemeEvents.subscribe(
          window.PUB_SUB_EVENTS?.variantChange || 'variant-change',
          (evt) => {
            if (evt?.data?.variant) {
              this.render(evt.data.variant.title);
            }
          }
        );
      }
      if (this.dataset.initialVariant) {
        this.render(this.dataset.initialVariant);
      }
    }
    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
    }
    render(variantTitle) {
      if (!this.data || this.data.length === 0) return;
      let selectedItem = this.data[0];
      if (variantTitle) {
        const normalizeSize = (str) => {
          const s = str.toLowerCase().trim();
          if (s === 'medium' || s === 'med') return 'medium';
          if (s === 'extra large' || s === 'xl') return 'extra large';
          return s;
        };

        const match = this.data.find(item => {
          const sizeVal = (item.size || item.heading || item.title || "").toLowerCase().trim();
          if (!sizeVal) return false;

          const variantParts = variantTitle.split(' / ').map(p => p.trim().toLowerCase());

          return variantParts.some(part => {
            const normPart = normalizeSize(part);
            const normSize = normalizeSize(sizeVal);
            if (normPart === normSize) return true;

            // Remove special characters and compare (e.g., "40-cm" vs "40cm")
            const cleanPart = part.replace(/[^a-z0-9]/g, '');
            const cleanSize = sizeVal.replace(/[^a-z0-9]/g, '');
            if (cleanPart && cleanPart === cleanSize) return true;

            // Prefix sub-match with word boundary (e.g. "s (1-2kg)" matches "s")
            if (sizeVal.startsWith(part) && !/[a-z0-9]/.test(sizeVal.charAt(part.length))) {
              return true;
            }
            if (part.startsWith(sizeVal) && !/[a-z0-9]/.test(part.charAt(sizeVal.length))) {
              return true;
            }

            return false;
          });
        });
        if (match) selectedItem = match;
      }
      const iconEl = this.querySelector('.recommended-icon img');
      const textEl = this.querySelector('.recommended-text');
      if (selectedItem.image) {
        iconEl.src = selectedItem.image;
        iconEl.style.display = 'block';
      } else {
        iconEl.style.display = 'none';
      }
      if (selectedItem.text) {
        textEl.innerHTML = selectedItem.text;
        if (!textEl.innerHTML.includes('<strong>')) {
          textEl.innerHTML = textEl.innerHTML.replace('Perfect for', '<strong>Perfect for</strong>');
        }
      }
    }
  });
}
